export enum AmbassadorPopupAudience {
  ALL_STUDENTS = 'all_students',
  STUDENTS_IN_COURSES = 'students_in_courses',
  SPECIFIC_STUDENTS = 'specific_students'
}
